// userManagment

import { Purchase                                  } from '../purchaseManagment/types';

import { DetailledIpAddressInformations            ,
         initializedDetailledIpAddressInformations } from '../networkManagment/types';

import { CustomerFrontEvent                        } from '../customerFrontEventManagment/types';

export const USER_STATUS_VALUES = [ 'Discover'   , 'Standard' , 'Premium' ];
export const USER_STATUS_LABELS = [ 'Découverte' , 'Standard' , 'Premium' ];

// Pays proposés par UserSheet — à garder synchronisé avec le Select "Pays :" de ce composant.
export const USER_COUNTRY_VALUES = [ 'France' , 'Belgique' , 'Suisse' ];

export interface UserStatus {
  id:    number ,
  value: number ,
  name:  string 
}

export const initializedUserStatus = (): UserStatus => ( 
 { 
  id:    0 ,
  value: 0 ,
  name:  '' 
 }
)

export interface User
 {
  id:                  number      ,
  creationDate:        Date | null ,
  creationIpAddress:   string      ,
  email:               string      ,
  emailValidationDate: Date | null ,
  status:              string      ,
  statusDeadline:      Date | null ,
  locked:              boolean     ,

  nextStatus                                      : string,
  nextStatusRequestDate                           : Date | null ,
  nextStatusRequestIpAddress                      : string,
  state                                           : string,
  closureDate                                     : Date | null ,
  closureIpAddress                                : string,
  lastBanDate                                     : Date | null ,
  lastUpdateIpAddress                             : string,
  lastUpdateDate                                  : Date | null ,
  emailValidationToken                            : string,
  emailValidationIpAddress                        : string,
  emailValidationReminder                         : string,
  lastPasswordResetRequestIpAddress               : string,
  lastPasswordResetRequestDate                    : Date | null ,
  lastPasswordResetToken                          : string,
  lastPasswordResetIpAddress                      : string,
  lastPasswordResetDate                           : Date | null ,
  lastEmailResetRequestIpAddress                  : string,
  lastEmailResetRequestDate                       : Date | null ,
  lastEmailResetToken                             : string,
  lastEmailResetIpAddress                         : string,
  lastEmailResetDate                              : Date | null ,
  lastEmailResetPreviousEmail                     : string,
  lastEmailResetPreviousEmailValidationToken      : string,
  lastEmailResetPreviousEmailValidationIpAddress  : string,
  lastEmailResetPreviousEmailValidationDate       : Date | null ,

  ipApiCom_country       : string      ,
  ipApiCom_city          : string      ,
  ipApiCom_lat           : number      ,
  ipApiCom_lon           : number      ,
  ipApiCom_isp           : string      ,

  firstname:           string      ,
  lastname:            string      ,
  sex:                 string      ,
  birthday:            Date | null ,
  address:             string      ,
  address2:            string      ,
  address3:            string      ,
  zipCode:             string      ,
  city:                string      ,
  country:             string      ,
  phoneNumber:         string      ,

  lastLoginDate:       Date | null ,
  lastLoginIpAddress:  string ,
  lastLoginCity:       string ,
  purchases:           Purchase[]  ,
 }

export interface UserList
 {
  users: User[]
 }

export const initializedUser = (): User => ( 
 {
  id:                  0     ,
  creationDate:        null  ,
  creationIpAddress:   ""    ,
  email:               ""    ,
  emailValidationDate: null  ,
  status:              ""    ,
  statusDeadline:      null  ,
  locked:              false  ,

  nextStatus                                      : '',
  nextStatusRequestDate                           : null ,
  nextStatusRequestIpAddress                      : '',
  state                                           : '',
  closureDate                                     : null ,
  closureIpAddress                                : '',
  lastBanDate                                     : null ,
  lastUpdateIpAddress                             : '',
  lastUpdateDate                                  : null ,
  emailValidationToken                            : '',
  emailValidationIpAddress                        : '',
  emailValidationReminder                         : '',
  lastPasswordResetRequestIpAddress               : '',
  lastPasswordResetRequestDate                    : null ,
  lastPasswordResetToken                          : '',
  lastPasswordResetIpAddress                      : '',
  lastPasswordResetDate                           : null ,
  lastEmailResetRequestIpAddress                  : '',
  lastEmailResetRequestDate                       : null ,
  lastEmailResetToken                             : '',
  lastEmailResetIpAddress                         : '',
  lastEmailResetDate                              : null ,
  lastEmailResetPreviousEmail                     : '',
  lastEmailResetPreviousEmailValidationToken      : '',
  lastEmailResetPreviousEmailValidationIpAddress  : '',
  lastEmailResetPreviousEmailValidationDate       : null ,

  ipApiCom_country       : ''      ,
  ipApiCom_city          : ''      ,
  ipApiCom_lat           : 0      ,
  ipApiCom_lon           : 0      ,
  ipApiCom_isp           : ''      ,

  firstname:           ""    ,
  lastname:            ""    ,
  sex:                 ""    ,
  birthday:            null  ,
  address:             ""    ,
  address2:            ""    ,
  address3:            ""    ,
  zipCode:             ""    ,
  city:                ""    ,
  country:             ""    ,
  phoneNumber:         ""    ,

  lastLoginDate:       null  ,
  lastLoginIpAddress:  "" ,
  lastLoginCity:       "" ,
  purchases:           []    ,
});

export interface EnrichedUser extends User {
  ipDetails? : DetailledIpAddressInformations ,
}

export const initializedEnrichedUser = (): EnrichedUser => ({
  ...initializedUser()                       ,
  ipDetails : initializedDetailledIpAddressInformations() ,
});

export interface EnrichedUserList
 {
  users: EnrichedUser[]
 }

export interface GetUserListParams {
  beginningDate? : Date;
  endingDate?    : Date;
  filter?        : string;
  status?        : string;
}

export interface AuthenticationEvent extends CustomerFrontEvent {}

export interface UserAuthenticationResult {
  date      : Date | null;
  status    : string;
  id        : number;
  firstName : string;
  lastName  : string;
  email     : string;
  ipAddress : string;
  
  country       : string      ;
  city          : string      ;
  lat           : number      ;
  lon           : number      ;
  isp           : string      ;
  origin?       : string | null ;   // hôte du site d'où est partie la connexion (kleon.tv, room.…), absent des anciens logs
  role?         : string | null ;   // « créateur » (régie) ou « user » (spectateur) — onglet Trafic du Dashboard, 2026-10-17
  app?          : 'ios' | 'android' | null ;   // d'après l'en-tête App-Informations
  firstTime?    : boolean       ;   // première connexion réussie de ce compte
  unknown?      : boolean       ;   // tentative refusée dont l'identifiant ne correspond à aucun compte (id = 0)
  reason?       : string | null ;   // motif d'un refus : « Compte inconnu », « Mot de passe incorrect »…
}

export const initializedUserAuthenticationResult = (): UserAuthenticationResult => ({
  date      : null,
  status    : '',
  id        : 0,
  firstName : '',
  lastName  : '',
  email     : '',
  ipAddress : '',
  
  country       : '',
  city          : '',
  lat           : 0,
  lon           : 0,
  isp           : ''
});
